export default class Constants {
  static ProfilePath = '/profile';
  static BasePageSegment = 'personal-informations';
  static BasePagePath = `/${Constants.BasePageSegment}`;

  // Consent Segments
  static ConsentConfirmationFormPageSegment = 'consent/confirmation';
  static ConsentFormPageSegment = 'consent/change';
  // Consent
  static ConsentConfirmationFormPagePath = `${Constants.BasePagePath}/${Constants.ConsentConfirmationFormPageSegment}`;
  static ConsentFormPagePath = `${Constants.BasePagePath}/${Constants.ConsentFormPageSegment}`;

  // Personal infos Segments
  static PersonalInformationsFormPageSegment = 'change';
  static PersonalInformationsConfirmationPageSegment = `${Constants.PersonalInformationsFormPageSegment}/confirmation`;
  static PersonalInformationsIntroductionPageSegment = `${Constants.PersonalInformationsFormPageSegment}/introduction`;

  // Personal infos
  static PersonalInformationsFormPagePath = `${Constants.BasePagePath}/${Constants.PersonalInformationsFormPageSegment}`;
  static PersonalInformationsConfirmationPagePath = `${Constants.PersonalInformationsFormPagePath}/confirmation`;
  static PersonalInformationsIntroductionPagePath = `${Constants.PersonalInformationsFormPagePath}/introduction`;
}
